import type { StorageServiceVersions } from "../types";

export const removeVersionAndRefresh = (
  versions: StorageServiceVersions,
  selectedId: string,
  selectedVersionId: string
) => {
  const newVersions = Object.fromEntries(
    Object.entries(versions as StorageServiceVersions).map(([id, items]) => [
      id,
      id === selectedId
        ? items.filter((item) => item.version_id !== selectedVersionId)
        : items,
    ])
  );
  const objectVersions = newVersions[selectedId as string];

  return { newVersions, objectVersions };
};
